
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"
import Switch from "./components/Switch"



function Modal ({titr,items,onChange,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <h2 style={{textAlign:'center'}} >
        {titr}
      </h2>
      {items}
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};




function ConfigSetting ({socket}){
  const location = useLocation ();
  const [name,setName] = useState (location.state.name);
  const navigate = useNavigate ();

  const [change,setChange]=useState (false);
  const [modalHoter,setModalHoter]=useState (false);
  const [modalColer,setModalColer]=useState (false);

  const [num_sensor,setNum_sensor]=useState (location.state.num_sensor+'');
  const [num_hoter,setNum_hoter]=useState (location.state.num_hoter+'');
  const [num_coler,setNum_coler]=useState (location.state.num_coler+'');
  const [num_window,setNum_window]=useState (location.state.num_window+'');

  const [hoter_config,setHoter_config]=useState (location.state.hoter_config);
  const [active_hoter,setActive_hoter]=useState (location.state.active_hoter);

  const [hoter_config_in,setHoter_config_in]=useState ([]);
  const [active_hoter_in,setActive_hoter_in]=useState ([]);
  const [coler_config,setColer_config]=useState (location.state.coler_config);
  const [coler_config_in,setColer_config_in]=useState ([]);

  const [hoter_time,setHoter_time]=useState (location.state.hoter_time+'');
  const [hoter_count,setHoter_count]=useState (location.state.hoter_count+'');

  useEffect (()=>{
//    setNum_sensor (JSON.stringify(location.state.num_sensor));
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
    {
      modalHoter && (
    <Modal
      titr="تنظیم بخاری ها"
      items={
            <div>
            {
              hoter_config_in.map ( (item,key)=>{
              return(
            <div  key={key}  style={{flex:1}}  className="row"  >
              <h2 style={{flex:.8}}>
                {" بخاری "+(key+1)+" به سنسور "}
              </h2>

              <input style={{margin:10,padding:5,fontSize:20, flex:.1,width:"50%",borderRadius:4}}
              type="tel"
              placeholder = ""
              onChange={(val)=>{var a=hoter_config_in; a[key]=val.target.value+''; setHoter_config_in (a); setChange (!change); }}
              value={hoter_config_in[key]+''}
              />
              {(location.state.active_hoter!=undefined)?
                <div style={{padding:0,marginTop:14}}>
                  <Switch style={{padding:20,margin:20}}
                    value={active_hoter_in[key]}
                    onChange={()=>{var a=active_hoter_in; a[key]=(a[key]==false) ? true : false;  setActive_hoter_in (a); setChange (!change); }}
                  />
                </div>
                :null}
              </div>
          )})
        }
          <div style={{flex:1}}  className="row"  >
          <button    style={style.button}
            onClick={()=>{
              setHoter_config (hoter_config_in);
              setActive_hoter (active_hoter_in);
              setModalHoter (false);
            }} >
            تایید
          </button>
          <button    style={style.button}
            onClick={()=>{
              setModalHoter (false)
            }} >
            کنسل
          </button>
          </div>

          </div>

      }
     />
    )}


    {
      modalColer && (
    <Modal
      titr="تنظیم کولر ها"
      items={
            <div>
            {
              coler_config_in.map ( (item,key)=>{
              return(
            <div  key={key}  style={{flex:1}}  className="row"  >
              <h2 style={{flex:.8}}>
                {" کولر "+(key+1)+" به سنسور "}
              </h2>

              <input style={{margin:10,padding:5,fontSize:20, flex:.1,width:"50%",borderRadius:4}}
              type="tel"
              placeholder = ""
              onChange={(val)=>{var a=coler_config_in; a[key]=val.target.value+''; setColer_config_in (a); setChange (!change); }}
              value={coler_config_in[key]+''}
              />
            </div>
          )})
        }
          <div style={{flex:1}}  className="row"  >
          <button    style={style.button}
            onClick={()=>{
              setColer_config (coler_config_in);
              setModalColer (false)
            }} >
            تایید
          </button>
          <button    style={style.button}
            onClick={()=>{
              setModalColer (false)
            }} >
            کنسل
          </button>
          </div>

          </div>

      }
     />
    )}




      <div style={style.content}>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0, borderRadius:8}}>
        <h2 style={{textAlign:"center",color:"white" ,padding:0,margin:5}}>
          تعداد سنسور
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={num_sensor}
          onChange = {(e)=>{setNum_sensor (e.target.value)}}/>
          <div style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5}}>
          </div>
        </div>
      </div>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0,borderRadius:6}}>
        <h2 style={{textAlign:"center",color:"white",padding:0,margin:5}}>
          تعداد بخاری
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={num_hoter}
          onChange = {(e)=>{setNum_hoter (e.target.value)}}/>
          <button style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5,backgroundColor:"red",color:"white"}}
            onClick ={()=>{
              let a=[];
              let b=[];
              for (let i=0;i<num_hoter;i++)
              {
                a.push ((hoter_config[i]!=undefined)?hoter_config[i]:(i+1)+'');
                b.push ((active_hoter!=undefined && active_hoter[i]!=undefined)?active_hoter[i]:true);
              }
              setHoter_config_in (a);
              setActive_hoter_in (b);
              setModalHoter (true);
            }}>
             تنظیم بخاری
          </button>

        </div>
      </div>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0,borderRadius:6}}>
        <h2 style={{textAlign:"center",color:"white",padding:0,margin:5}}>
          تعداد کولر
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={num_coler}
          onChange = {(e)=>{setNum_coler (e.target.value)}}/>
          <button style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5,backgroundColor:"red",color:"white"}}
          onClick ={()=>{
            let a=[];
            for (let i=0;i<num_coler;i++)
              a.push ((coler_config[i]!=undefined)?coler_config[i]:(i+1)+'');
            setColer_config_in (a);
            setModalColer (true);
          }}>
             تنظیم کولر
          </button>

        </div>
      </div>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0, borderRadius:8}}>
        <h2 style={{textAlign:"center",color:"white" ,padding:0,margin:5}}>
          تعداد پنجره
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={num_window}
          onChange = {(e)=>{setNum_window (e.target.value)}}/>
          <div style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5}}>
          </div>
        </div>
      </div>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0, borderRadius:8}}>
        <h2 style={{textAlign:"center",color:"white" ,padding:0,margin:5 }}>
          مدت زمان روشن شدن بخاری
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={hoter_time}
          onChange = {(e)=>{setHoter_time (e.target.value)}}/>
          <div style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5}}>
          </div>
        </div>
      </div>

      <div style={{backgroundColor:"#00afff",margin:0,padding:10,paddingTop:0, borderRadius:8}}>
        <h2 style={{textAlign:"center",color:"white" ,padding:0,margin:5}}>
          تعداد تلاش برای روشن کردن بخاری
        </h2>
        <div className="row">
          <input style={style.input}
          type="tel"
          placeholder = ""
          value={hoter_count}
          onChange = {(e)=>{setHoter_count (e.target.value)}}/>
          <div style={{padding:14,marginLeft:10,marginRight:10, fontSize:16, borderRadius:8,flex:.5}}>
          </div>
        </div>
      </div>

    </div>
    <button className='btn'
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SET_MENU_CONFIG" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });


        SendData (socket,'data',{
          "event":"set_menu_config",
          "data":{
            "num_sensor":num_sensor,
            "num_hoter":num_hoter,
            "num_coler":num_coler,
            "num_window":num_window,
            "hoter_config":hoter_config,
            "active_hoter":active_hoter,
            "coler_config":coler_config,
            "hoter_time":hoter_time,
            "hoter_count":hoter_count,
          }});
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
  //  display:"flex",
    width:"90%",
    alignItems:"center",
    padding:14,
  //  backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:10,
    margin:10
  },
  input:{
    width:"90%",
    maxWidth:820,
    padding:10,
    fontSize:20,
    borderRadius:8,
    flex:.5,
    textAlign:"center",
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer",
    margin:5
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default ConfigSetting;
